import selections from '@/store/mutations/selections.ts'
import presentation from '@/store/mutations/presentation.ts'
import questions from '@/store/mutations/questions.ts'

export default {
  ...presentation,
  ...selections,
  ...questions,
}
